import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const postEvent = async (payload) => {
  try {
    const res = await postRequest({ url: "/events", payload: payload });
    return res;
  } catch (e) {
    throw e;
  }
};

export const putEvent = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "/events",
      payload: payload,
      query: { event_id: id },
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const getEvents = async (query) => {
  try {
    const res = await getRequest({
      url: "/events",
      query: query,
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const postEventGallery = async (payload) => {
  try {
    const res = await postRequest({ url: "/events/gallery", payload: payload });
    return res;
  } catch (e) {
    throw e;
  }
};
